export const LOCALSTORAGE_TOKEN = "daemon-crm-token";
